/* eslint-disable require-yield */
/* eslint-disable no-plusplus */
/* eslint-disable object-shorthand */
/* eslint-disable dot-notation */
/* eslint-disable prefer-const */
import { message, notification } from 'antd'
import axios from 'axios'
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import {
  createLearner,
  createLearnersProgram,
  getClinicLearners,
  getLearner,
  getLearnerAttendanceReportByClinic,
  getLearnerAttendanceReportByLearner,
  getLearnerAttendanceReportByStaff,
  getLearnersDropdown,
  learnerActiveInactive,
  updateLearner,
} from 'services/learners'
import { USER_TYPES } from 'constants/user'
import { REACT_APP_API_URL } from 'apollo/REACT_APP_URL'
import actions from './actions'

export function* GET_DATA({ payload }) {
  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loading: true,
      LearnersList: [],
      categoryList: [],
      languageList: [],
      clinicLocationList: [],
      staffDropdownList: [],
      UserProfile: null,
      isUserProfile: false,
      TotalLearners: 0,
      PageInfo: null,
    },
  })
  const status = yield select(state => state.learners.CurrentStatus)
  let active = null
  if (status === 'all') active = null
  if (status === 'active') active = true
  if (status === 'in-active') active = false

  yield put({
    type: 'learners/GET_LEARNERS',
    payload: {
      isActive: active,
      first: 15,
      last: null,
      after: null,
      before: null,
      ...payload,
    },
  })

  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

const updateResponse = response => {
  const learners = []
  let i = 0
  if (response.data.students.edges && response.data.students.edges.length > 0) {
    for (i = 0; i < response.data.students.edges.length; i++) {
      if (
        response.data.students.edges[i].node.tags.edges &&
        response.data.students.edges[i].node.tags.edges.length > 0
      ) {
        const tempTagArr = response.data.students.edges[i].node.tags.edges.map(e => e.node.name)
        response.data.students.edges[i].node.tags = tempTagArr
      }

      learners.push(response.data.students.edges[i].node)
    }
  }

  return learners
}

export function* GET_LEARNERS({ payload }) {
  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loadingLearners: true,
    },
  })

  const response = yield call(getClinicLearners, payload)
  if (response) {
    let learners = updateResponse(response)
    let pageInfo = response?.data?.students?.pageInfo
    let totalLearners = response?.data?.students?.clinicTotal
    let endCursor = pageInfo?.endCursor
    yield put({
      type: 'learners/SET_STATE',
      payload: {
        loadingLearners: false,
        LearnersList: learners,
        TotalLearners: totalLearners,
        PageInfo: pageInfo,
      },
    })

    // if (pageInfo?.hasNextPage) {
    //   let allLearners = [...learners]
    //   while (pageInfo?.hasNextPage) {
    //     const res2 = yield call(getClinicLearners, {
    //       isActive: payload.isActive,
    //       first: payload.first,
    //       last: null,
    //       after: endCursor,
    //       before: null,
    //     })
    //     pageInfo = res2?.data?.students?.pageInfo
    //     endCursor = pageInfo?.endCursor
    //     allLearners = [...allLearners, ...updateResponse(res2)]
    //     yield put({
    //       type: 'learners/SET_STATE',
    //       payload: {
    //         loadingLearners: false,
    //         LearnersList: allLearners,
    //         PageInfo: pageInfo,
    //       },
    //     })
    //   }
    // }
  }
}

export function* PAGE_CHANGED2({ payload }) {
  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loadingLearners: true,
    },
  })
  // // console.log(payload, 'payload')
  let pageInfo = yield select(state => state.learners.PageInfo)
  const learners = yield select(state => state.learners.LearnersList)
  let endCursor = pageInfo?.endCursor

  const status = yield select(state => state.learners.CurrentStatus)
  const perPage = yield select(state => state.learners.ItemPerPage)
  let active = null
  if (status === 'all') active = null
  if (status === 'active') active = true
  if (status === 'in-active') active = false

  if (pageInfo?.hasNextPage) {
    let allLearners = [...learners]

    const res2 = yield call(getClinicLearners, {
      isActive: active,
      first: payload.first,
      last: null,
      after: endCursor,
      before: null,
    })
    pageInfo = res2?.data?.students?.pageInfo
    endCursor = pageInfo?.endCursor
    allLearners = [...allLearners, ...updateResponse(res2)]
    yield put({
      type: 'learners/SET_STATE',
      payload: {
        loadingLearners: false,
        LearnersList: allLearners,
        PageInfo: pageInfo,
      },
    })
  }

  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loadingLearners: false,
    },
  })
}
export function* PAGE_CHANGED({ payload }) {
  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loadingLearners: true,
    },
  })
  // // console.log(payload, 'payload')
  const pageInfo = yield select(state => state.learners.PageInfo)
  const status = yield select(state => state.learners.CurrentStatus)
  const perPage = yield select(state => state.learners.ItemPerPage)
  let active = null
  if (status === 'all') active = null
  if (status === 'active') active = true
  if (status === 'in-active') active = false

  const currentPage = yield select(state => state.learners.CurrentPage)
  let after = null
  let before = null
  let last = null
  let first = perPage

  if (payload.page === 1) {
    after = null
    before = null
  } else if (payload.page >= payload.rows / perPage) {
    after = null
    before = null
    first = null
    last = payload.rows % perPage
  } else if (payload.page > currentPage) {
    after = pageInfo.endCursor
  } else if (payload.page < currentPage) {
    before = pageInfo.startCursor
  }

  // console.log(active, first, after, before, last, 'in page changes')
  // const response = null
  const response = yield call(getClinicLearners, { isActive: active, first, after, before, last })

  const oldLearners = []
  // console.log(response, 'thia ia respsonse')
  if (response) {
    let i = 0
    if (response.data.students.edges.length > 0) {
      for (i = 0; i < response.data.students.edges.length; i++) {
        if (
          response.data.students.edges[i].node.tags.edges &&
          response.data.students.edges[i].node.tags.edges.length > 0
        ) {
          const tempTagArr = response.data.students.edges[i].node.tags.edges.map(e => e.node.name)
          response.data.students.edges[i].node.tags = tempTagArr
        }
        oldLearners.push(response.data.students.edges[i].node)
      }
    }

    yield put({
      type: 'learners/SET_STATE',
      payload: {
        LearnersList: oldLearners,
        TotalLearners: response.data.students.clinicTotal,
        PageInfo: response.data.students.pageInfo,
        CurrentPage: payload.page,
      },
    })
  }
  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loadingLearners: false,
    },
  })
}

export function* ROWS_CHANGED({ payload }) {
  // console.log(payload, 'payload')
  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loadingLearners: true,
    },
  })
  const pageInfo = yield select(state => state.learners.PageInfo)
  // console.log(pageInfo, 'pageInfo')
  const status = yield select(state => state.learners.CurrentStatus)
  // console.log(status, 'status')
  const totalLearners = yield select(state => state.learners.TotalLearners)
  // console.log(totalLearners, 'totalLearners')
  let active = null
  if (status === 'all') active = null
  if (status === 'active') active = true
  if (status === 'in-active') active = false

  let after = null
  let before = null
  let last = null
  let first = payload.currentRowsPerPage

  if (payload.currentPage === 1) {
    after = null
    before = null
  } else if (payload.currentPage >= totalLearners / payload.currentRowsPerPage) {
    after = null
    before = null
    first = null
    last = totalLearners % payload.currentRowsPerPage
  }

  // console.log(first, after, before, last, 'before alas')
  const response = yield call(getClinicLearners, { isActive: active, first, after, before, last })
  // const response = null
  const oldLearners = []
  if (response) {
    let i = 0
    if (response.data.students.edges.length > 0) {
      for (i = 0; i < response.data.students.edges.length; i++) {
        if (
          response.data.students.edges[i].node.tags.edges &&
          response.data.students.edges[i].node.tags.edges.length > 0
        ) {
          const tempTagArr = response.data.students.edges[i].node.tags.edges.map(e => e.node.name)
          response.data.students.edges[i].node.tags = tempTagArr
        }

        oldLearners.push(response.data.students.edges[i].node)
      }
    }

    // console.log(response)
    yield put({
      type: 'learners/SET_STATE',
      payload: {
        LearnersList: oldLearners,
        TotalLearners: response.data.students.clinicTotal,
        PageInfo: response.data.students.pageInfo,
        CurrentPage: 1,
        ItemPerPage: payload.currentRowsPerPage,
      },
    })
  }
  yield put({
    type: 'learners/SET_STATE',
    payload: {
      loadingLearners: false,
    },
  })
}

export function* GET_LEARNERS_DROPDOWNS() {
  const response = yield call(getLearnersDropdown)

  if (response && response.data) {
    yield put({
      type: 'learners/SET_STATE',
      payload: {
        categoryList: response.data.category,
        clinicLocationList: response.data.schoolLocation.edges,
        staffDropdownList: response.data.staffs.edges,
        languageList: response.data.languages,
      },
    })
  }
}

export function* EDIT_GENERAL_INFO({ payload }) {
  const { response } = payload
  if (response && response.data) {
    notification.success({
      message: 'Learner Updated Successfully',
    })

    let updatedLearner = response.data.updateStudent.student
    if (response.data.updateStudent.student) {
      if (response.data.updateStudent.student.tags.edges.length > 0) {
        const tempTagArr = response.data.updateStudent.student.tags.edges.map(e => e.node.name)
        updatedLearner = { ...updatedLearner, tags: tempTagArr }
      } else {
        updatedLearner = { ...updatedLearner, tags: [] }
      }

      if (response.data.updateStudent.student.allergicTo?.edges.length > 0) {
        const tempAllergyArr = response.data.updateStudent.student.allergicTo?.edges.map(
          e => e.node.name,
        )
        updatedLearner = { ...updatedLearner, allergicTo: tempAllergyArr }
      } else {
        updatedLearner = { ...updatedLearner, allergicTo: [] }
      }

      if (response.data.updateStudent.student.sessionpreferreditemSet?.edges.length > 0) {
        const tempPrefferedItems = response.data.updateStudent.student.sessionpreferreditemSet?.edges.map(
          e => e.node.item,
        )
        updatedLearner = { ...updatedLearner, preferreditemsSet: tempPrefferedItems }
      } else {
        updatedLearner = { ...updatedLearner, preferreditemsSet: [] }
      }
    }

    const obj = {
      id: updatedLearner.id,
      caseManager: updatedLearner.caseManager,
      category: updatedLearner.category,
      email: updatedLearner.email,
      firstname: updatedLearner.firstname,
      lastname: updatedLearner.lastname,
      gender: updatedLearner.gender,
      isActive: updatedLearner.isActive,
      mobileno: updatedLearner.mobileno,
      parentMobile: updatedLearner.parentMobile,
      tags: updatedLearner.tags,
    }

    // console.log(updatedLearner, obj, 'updated kjfbsdf ksf')
    yield put({
      type: 'learners/UPDATE_LERNERS_LIST',
      payload: {
        object: obj,
      },
    })

    yield put({
      type: 'learners/SET_STATE',
      payload: {
        UserProfile: updatedLearner,
      },
    })
  }
}

export function* EDIT_LEARNER({ payload }) {
  const response = yield call(updateLearner, payload)
  if (response && response.data) {
    notification.success({
      message: 'Learner Updated Successfully',
    })

    let updatedLearner = response.data.updateStudent.student
    if (response.data.updateStudent.student) {
      if (response.data.updateStudent.student.tags.edges.length > 0) {
        const tempTagArr = response.data.updateStudent.student.tags.edges.map(e => e.node.name)
        updatedLearner = { ...updatedLearner, tags: tempTagArr }
      }
      if (response.data.updateStudent.student.allergicTo?.edges.length > 0) {
        const tempAllergyArr = response.data.updateStudent.student.allergicTo?.edges.map(
          e => e.node.name,
        )
        updatedLearner = { ...updatedLearner, allergicTo: tempAllergyArr }
      }

      if (response.data.updateStudent.student.sessionpreferreditemSet?.edges.length > 0) {
        const tempPrefferedItems = response.data.updateStudent.student.sessionpreferreditemSet?.edges.map(
          e => e.node.item,
        )
        updatedLearner = { ...updatedLearner, preferreditemsSet: tempPrefferedItems }
      } else {
        updatedLearner = { ...updatedLearner, preferreditemsSet: [] }
      }
    }

    yield put({
      type: 'learners/UPDATE_LERNERS_LIST',
      payload: {
        object: updatedLearner,
      },
    })

    yield put({
      type: 'learners/SET_STATE',
      payload: {
        UserProfile: updatedLearner,
      },
    })
  }
}

export function* CREATE_LEARNER({ payload }) {
  const response = yield call(createLearner, payload)

  if (response && response.data) {
    // generating notification
    notification.success({
      message: 'Learner Created Successfully',
    })

    yield put({
      type: 'learners/SET_STATE',
      payload: {
        saveDisabled: false,
      },
    })

    let token = ''
    if (!(localStorage.getItem('token') === null) && localStorage.getItem('token')) {
      token = JSON.parse(localStorage.getItem('token'))
    }
    const headers = {
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
      database: 'india',
      Authorization: token ? `JWT ${token}` : '',
    }
    payload.data.append('pk', response.data.createStudent.student.id)
    axios
      .post(`${REACT_APP_API_URL}/student-docs/`, payload.data, {
        headers: headers,
      })
      .then(res => {
        // then print response status
        message.success('Upload Successfully.')
      })
      .catch(err1 => {
        // console.error({ err1 })
        message.error('upload Failed.')
        return false
      })

    yield put({
      type: 'learners/APPEND_LERNERS_LIST',
      payload: {
        student: response.data.createStudent.student,
      },
    })

    if (payload.values.program && payload.values.program !== '') {
      const programResponse = yield call(createLearnersProgram, {
        id: response.data.createStudent.student.id,
        program: payload.values.program,
      })

      if (programResponse && programResponse.data) {
        notification.success({
          message: programResponse.data.createProgramsByLevel.msg,
        })
      }
    }
  }
}

export function* LEARNER_ACTIVE_INACTIVE({ payload }) {
  const response = yield call(learnerActiveInactive, payload)

  if (response && response.data) {
    // generating notification
    if (payload.checked === true) {
      notification.success({
        message: 'Learner Activated Successfully',
      })
    } else {
      notification.success({
        message: 'Learner Deactivated Successfully',
      })
    }

    yield put({
      type: 'learners/UPDATE_LEARNER_ACTIVE_INACTIVE',
      payload: {
        student: response.data.updateStudent.student,
      },
    })
  }
}

export function* GET_SINGLE_LEARNER({ payload }) {
  const response = yield call(getLearner, payload.UserProfile)

  if (response && response.data) {
    // generating notification
    const userData = {
      ...response.data.student,
      tags: response.data.student.tags
        ? response.data.student.tags.edges.map(item => item.node.name)
        : [],
      allergicTo: response.data.student.allergicTo
        ? response.data.student.allergicTo.edges.map(item => item.node.name)
        : [],
      preferreditemsSet: response.data.student.sessionpreferreditemSet
        ? response.data.student.sessionpreferreditemSet.edges.map(item => item.node.item)
        : [],
    }

    yield put({
      type: 'learners/SET_STATE',
      payload: {
        UserProfile: userData,
        isUserProfile: true,
      },
    })
  }
}

export function* GET_LEARNER_ATTENDANCE_REPORT({ payload }) {
  yield put({
    type: 'learners/SET_STATE',
    payload: {
      isAttendanceReportLoading: true,
    },
  })
  // // console.log(payload, 'payload')
  const { role } = yield select(state => state.user)

  if (role === USER_TYPES.Clinic) {
    const response = yield call(getLearnerAttendanceReportByClinic, { ...payload })
    if (response) {
      yield put({
        type: 'learners/SET_STATE',
        payload: {
          learnerAttendance: response.getLearnerAttendeceReport,
        },
      })
    }
  }
  if (role === USER_TYPES.Therapist) {
    const response = yield call(getLearnerAttendanceReportByStaff, { ...payload })
    if (response) {
      yield put({
        type: 'learners/SET_STATE',
        payload: {
          learnerAttendance: response.getLearnerAttendenceReportByStaff,
        },
      })
    }
  }
  if (role === USER_TYPES.Parent) {
    const response = yield call(getLearnerAttendanceReportByLearner, { ...payload })
    if (response) {
      yield put({
        type: 'learners/SET_STATE',
        payload: {
          learnerAttendance: response.getLearnerAttendenceReportByLearner,
        },
      })
    }
  }

  yield put({
    type: 'learners/SET_STATE',
    payload: {
      isAttendanceReportLoading: false,
    },
  })
}
export default function* rootSaga() {
  yield all([
    // GET_DATA(), // run once on app load to fetch menu data
    takeEvery(actions.GET_DATA, GET_DATA),
    takeLatest(actions.GET_LEARNERS, GET_LEARNERS),
    takeEvery(actions.GET_LEARNERS_DROPDOWNS, GET_LEARNERS_DROPDOWNS),
    takeEvery(actions.EDIT_LEARNER, EDIT_LEARNER),
    takeEvery(actions.CREATE_LEARNER, CREATE_LEARNER),
    takeEvery(actions.LEARNER_ACTIVE_INACTIVE, LEARNER_ACTIVE_INACTIVE),
    takeEvery(actions.PAGE_CHANGED, PAGE_CHANGED2),
    takeEvery(actions.ROWS_CHANGED, ROWS_CHANGED),
    takeEvery(actions.GET_SINGLE_LEARNER, GET_SINGLE_LEARNER),
    takeEvery(actions.EDIT_GENERAL_INFO, EDIT_GENERAL_INFO),
    takeEvery(actions.GET_LEARNER_ATTENDANCE_REPORT, GET_LEARNER_ATTENDANCE_REPORT),
  ])
}
